module.exports = "nav{\r\n    background-color: #1a237e;\r\n}\r\n"